import React from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer
      style={{
        background: "#020617",
        color: "#cbd5f5",
        padding: "30px 20px 20px", // Reduced top and bottom padding
        borderTop: "1px solid rgba(148,163,184,0.15)",
        fontFamily: "'Roboto', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "30px", // Slightly reduced gap
        }}
      >
        {/* Company Info */}
        <div>
          <h3 style={companyTitle}>Radiance Cloud Solutions</h3>
          <p style={companyDesc}>
            We design, build, migrate, and operate secure cloud infrastructure
            for startups and enterprises worldwide. Your cloud, our expertise.
          </p>
        </div>

        {/* Services */}
        <div>
          <h4 style={headingStyle}>Services</h4>
          <ul style={listStyle}>
            <li><Link to="cloud-architecture" smooth={true} style={linkStyle}>Cloud Architecture</Link></li>
            <li><Link to="migration-modernization" smooth={true} style={linkStyle}>Migration & Modernization</Link></li>
            <li><Link to="devops-automation" smooth={true} style={linkStyle}>DevOps & Automation</Link></li>
            <li><Link to="security-compliance" smooth={true} style={linkStyle}>Security & Compliance</Link></li>
            <li><Link to="cost-optimization" smooth={true} style={linkStyle}>Cost Optimization</Link></li>
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={headingStyle}>Quick Links</h4>
          <ul style={listStyle}>
            <li><Link to="services" smooth={true} style={linkStyle}>Services</Link></li>
            <li><Link to="portfolio" smooth={true} style={linkStyle}>Portfolio</Link></li>
            <li><Link to="whyus" smooth={true} style={linkStyle}>Why Choose Us</Link></li>
            <li><Link to="leadform" smooth={true} style={linkStyle}>Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div style={{ textAlign: "center" }}>
          <h4 style={headingStyle}>Contact</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, gap: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <li style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaEnvelope /> info@radiancecloudsolutions.com
            </li>
            <li style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaPhoneAlt /> +91 9345981014
            </li>
            <li style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaMapMarkerAlt /> Chennai, India
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={bottomBar}>
        © 2025 Radiance Cloud Solutions. All rights reserved.
      </div>
    </footer>
  );
};

/* ---------- Styles ---------- */

const companyTitle = {
  fontSize: "1.3rem",
  fontWeight: 800,
  marginBottom: "10px",
  color: "#38bdf8",
};

const companyDesc = {
  fontSize: "0.95rem",
  lineHeight: 1.5,
  color: "#94a3b8",
};

const headingStyle = {
  fontSize: "1rem",
  fontWeight: 700,
  marginBottom: "10px",
  color: "#e0e7ff",
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  fontSize: "0.9rem",
  color: "#94a3b8",
};

const linkStyle = {
  color: "#94a3b8",
  textDecoration: "none",
  cursor: "pointer",
  transition: "color 0.3s",
};

const bottomBar = {
  marginTop: "30px",
  paddingTop: "15px",
  borderTop: "1px solid rgba(148,163,184,0.12)",
  textAlign: "center",
  fontSize: "0.85rem",
  color: "#94a3b8",
};

export default Footer;
